import { useStores } from 'src/contexts/stores';

export default function useUser() {
  const { user } = useStores();

  return user;
}
